import React from "react";

const SelectedFieldsPanel = ({ selectedFieldsMap, onClearAll }) => {
  const hasSelections = Object.values(selectedFieldsMap).some(
    (fields) => fields.length > 0
  );

  return (
    <div className="mb-4 p-3 border rounded bg-light">
      <h5 className="fw-bold">🧾 Selected Fields</h5>

      {!hasSelections ? (
        <p className="text-muted">No fields selected yet.</p>
      ) : (
        <ul className="list-unstyled">
          {Object.entries(selectedFieldsMap).map(([table, fields]) =>
            fields.length > 0 ? (
              <li key={table}>
                <strong>{table}</strong>
                <ul>
                  {fields.map((f) => (
                    <li key={f.code}>{f.label}</li>
                  ))}
                </ul>
              </li>
            ) : null
          )}
        </ul>
      )}

      {hasSelections && (
        <button className="btn btn-sm btn-danger mt-2" onClick={onClearAll}>
          Clear All
        </button>
      )}
    </div>
  );
};

export default SelectedFieldsPanel;
